const URL = '/imputaciones_exportar';

const state = {
  loading: false,
  all: [],
  filters: {
    fecha_from: null,
    fecha_to: null,
    cuenta_id: null
  },
}

// GETTERS
const getters = {
  loading (state) {
    return state.loading
  },
  filters (state) {
    return state.filters
  },
  all (state) {
    return state.all
  },
}

// ACTIONS
const actions = {
  onClearFilters({ state, commit }) {
    commit('setFilters', {
      ...state.filters,
        fecha_from: null,
        fecha_to: null,
        cuenta_id: null
    })
  },
  onFetch ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, {
        fecha_from: state.filters.fecha_from,
        fecha_to: state.filters.fecha_to,
        cuenta_id: state.filters.cuenta_id
      })
        .then(response => {
          commit('setAll', response.data.data || [])
          resolve(response.data.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error al cargar las imputaciones', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
  onSave ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.post(URL, {
        fecha_from: state.filters.fecha_from,
        fecha_to: state.filters.fecha_to,
        cuenta_id: state.filters.cuenta_id
      })
        .then(response => {
          commit('ResponseHTTP/addSuccess', 'Se descargo la información de las imputaciones de la cuenta, en el periodo seleccionado', { root: true })
          resolve(response.data)
        })
        .catch(error => {
          commit('ResponseHTTP/addError', 'Error. No se descargo la informacion de las imputaciones de la cuenta, en el periodo seleccionado.', { root: true })
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setFilters (state, payload) {
    state.filters = payload
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setAll (state, payload) {
    state.all = payload.slice()
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

